import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router";
import "../shuttle_bus_booking.css";
import { Dialog } from "@progress/kendo-react-dialogs";
import { useDispatch, useSelector } from "react-redux";
import { SHUTTLE_BUS_BOOKING_ROUTE_LIST } from "../../../routes";
import { Button } from "@progress/kendo-react-buttons";
import { Loader } from "@progress/kendo-react-indicators";
import { checkPermission, getUserPermission } from "../../../config/permission_helper";
import { PermissionDeninedPage } from "../../../components/reusableItems/permission_denined";

import { Checkbox, TextBox } from "@progress/kendo-react-inputs";
import { createAndUpdateSetMaximum, fetchSetMaximumDetail } from "../../../store/shuttle_bus_booking/set_maximum";
import BackIcon from "../../../assets/communication/Back.svg";
import { createAndUpdateRoute, fetchRouteDetail } from "../../../store/shuttle_bus_booking/shuttle_bus_route";
import { fetchSetStationList } from "../../../store/shuttle_bus_booking/set_station";
import { ManageRoute } from "./route";

export const ShuttleBusBookingOrdinaryRouteAdd = () => {

  const navigate = useNavigate();
  let { search } = useLocation();
  const dispatch = useDispatch();
  const query = new URLSearchParams(search);

  const [errors, setErrors] = useState(false);
  const [showRequiredFieldError, setShowRequiredFieldError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showValidateError, setShowValidateError] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const [id, setId] = useState(
    query.get("id") ?? ""
  );

  const userPermissions = getUserPermission();

  const AddPermssion = checkPermission(
    userPermissions,
    "bus_booking.create_bus_booking_route"
  );

  const [editData, setEditData] = useState({
    bus_name: "",
    routes: [],
    status: "Active",
  });

  const [routes, setRoutes] = useState([]);



  const { detail_data, detail_loading } = useSelector(
    (state) => state.shuttleBusRoute
  );

  const { set_station_list } = useSelector(
    (state) => state.shuttleBusSetStation
  );


  const getData = async () => {
    dispatch(fetchSetStationList(id));
    dispatch(fetchRouteDetail(id));
  };


  useEffect(() => {
    getData();
  }, [id]);

  useEffect(() => {

    if (detail_data && id) {
      setEditData({
        bus_name: detail_data.bus_name,
        routes: detail_data.routes,
        status: detail_data.status,
      });
      setRoutes(detail_data?.routes || []);

    }


  }, [detail_data]);



  const handleSubmit = () => {
    if (checkMandatoryFields()) return;

    setLoading(true);

    editData.routes = routes;

    dispatch(createAndUpdateRoute({ data: editData, id })).then((res) => {
      const { payload } = res;
      if (payload.status === "success") {

        setLoading(false);
        if (id) {
          navigate(`${SHUTTLE_BUS_BOOKING_ROUTE_LIST}?type=ordinary`);
        } else {
          setShowSuccessPopup(true);
        }

      } else {
        setLoading(false);


      }
    });


  };

  const handleCloseDialog = () => {
    setShowSuccessPopup(false);
    navigate(`${SHUTTLE_BUS_BOOKING_ROUTE_LIST}?type=ordinary`);
  };

  const checkMandatoryFields = () => {
    const { bus_name } = editData;
    let hasError = false;

    if (!bus_name) {
      console.error("All fields must be filled.");
      hasError = true;
    }

    if (routes && routes.length > 0) {
      for (const route of routes) {
        if (!route.station_id || !route.time) {
          console.error("Route fields must be filled.");
          hasError = true;
          break;
        }
      }
    } else {
      console.error("Routes must not be empty.");
      hasError = true;
    }

    setShowRequiredFieldError(hasError);
    setShowValidateError(hasError);
    return hasError;
  }


  const callback_handleBackBtn = (e) => {

    navigate(`${SHUTTLE_BUS_BOOKING_ROUTE_LIST}?type=ordinary`);

  };


  return (
    <>
      {AddPermssion ? (
        <div style={{ height: "calc(100% - 75px)" }}>

          {errors && (
            <Dialog
              width={400}
              title={"Message"}
              onClose={() => setErrors(false)}
              className="error-message"
            >
              <p>{errors}</p>
            </Dialog>
          )}

          {showSuccessPopup && (
            <Dialog
              className="alert-form"
              title={"Alert"}
              width={400}
              // height={280}
              onClose={handleCloseDialog}
            >
              <p>Successfully Saved</p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "40px",
                    borderRadius: "5px",
                    background: "#eb6e1f",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={handleCloseDialog}
                >
                  OK
                </div>
              </div>
            </Dialog>
          )}

          {showRequiredFieldError && (
            <Dialog
              className="information-details-alert-form"
              title={"Alert"}
              onClose={() => setShowRequiredFieldError(false)}
            >
              <p
                style={{
                  margin: "25px",
                  textAlign: "center",
                }}
              >
                Please fill in all the required fields.
              </p>
            </Dialog>
          )}



          {(detail_loading || loading) && (
            <Loader
              type="converging-spinner"
              style={{
                width: "100%",
                height: "calc(100% - 75px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#ffffff4d",
                position: "absolute",
                zIndex: "999",
              }}
            />
          )}

          <div className="shuttle_bus_booking_body">
            <div className="shuttle_bus_booking_addheader" >
              <div className="back-title-group" onClick={(e) => callback_handleBackBtn(e)}>
                <img src={BackIcon} className="back-icon" />
                <span className="back-text">Back</span>
              </div>
            </div>
          </div>

          <div className="main-shuttle-bus-container">
            <div className="main-poll-survey">

              <div className="shuttle_bus_booking_create_scroll_box">


                <div className="shuttle_bus_booking_create_item_main_box">
                  <div className="shuttle_bus_booking_create_item_main_box_title">
                    Bus Name <span style={{ color: "red" }}>*</span>
                  </div>
                  <div>
                    <TextBox
                      className="shuttle_bus_booking_create_item_main_box_field"
                      value={editData.bus_name}
                      onChange={(e) =>
                        setEditData({
                          ...editData,
                          bus_name: e.target.value,
                        })
                      }
                    />

                  </div>
                </div>

                <div className="shuttle_bus_booking_create_item_main_box">
                  <div className="shuttle_bus_booking_create_item_main_box_title">
                    Route Setting
                  </div>
                  <div>
                    <ManageRoute routes={routes} setRoutes={setRoutes} stations={set_station_list || []} showValidateError={showValidateError} />

                  </div>
                </div>

                <div className="shuttle-bus-booking-status-main-box margin-bottom">
                  <Checkbox
                    style={{ border: "1px solid #CCCCCC" }}
                    name="userVisibility"
                    value="userVisibility"
                    onChange={(e) => {

                      setEditData((prevData) => ({
                        ...prevData,
                        status: e.target.value ? 'Active' : 'Inactive',
                      }));
                    }}
                    checked={editData.status == 'Active'}
                  />
                  <label>Bus route inactive</label>
                </div>



              </div>
            </div>

            <div className="campaigns-survey-footer">
              <div className="footer-left-btn-groups">
                <Button
                  className="footer-previous-btn font-family-poppins"
                  onClick={() => {
                    navigate(`${SHUTTLE_BUS_BOOKING_ROUTE_LIST}?type=ordinary`);
                  }}
                >
                  Cancel
                </Button>
              </div>


              <div className="footer-right">


                <Button
                  className="footer-next-btn"
                  onClick={(e) => {
                    handleSubmit();
                  }}
                >
                  Submit
                </Button>
              </div>


            </div>
          </div>



        </div>
      ) : (
        <PermissionDeninedPage
          height={"calc(100% - 76px)"}
          title={"Sorry, You don't have permission to access this page!"}
        />
      )}
    </>
  );
};
